import dayjs from 'dayjs';
import Text from '../../../components/detail/components/Text.component';
import { grey } from '@mui/material/colors';

export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      id: 'delivery_notes',
      type: 'section',
      label: 'Delivery Note',
      sx: { backgroundColor: '#e8eaf6CC' },
      sxTypography: {
        backgroundColor: '#c5cae9',
        fontSize: 14,
        fontWeight: 'bold',
        color: grey[700],
      },
      items: [
        {
          type: 'text',
          label: 'Number',
          key: 'attributes.delivery_note_number',
        },

        {
          type: 'text',
          label: 'Note',
          key: 'attributes.note',
          xs: 12,
        },
      ],
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'attributes.date':
        return (
          <Text label={'Date'} value={dayjs(value).format('DD-MM-YYYY')} />
        );

      case 'attributes.note':
        return (
          <Text
            sx={{ paddingRight: 3 }}
            label={'Note'}
            value={value.split('\n').map((line, index) => (
              <span
                key={index}
                style={{ textAlign: 'justify', display: 'block' }}
              >
                {line}
                <br />
              </span>
            ))}
          />
        );

      case 'attributes.delivery_note_number':
        return <></>;
      default:
        return null;
    }
  },
};
